import { Task } from './task.model';

export class TaskHistory  {
  constructor(
        public action?: any,
        public entityId?: any,
        public entityValue?: string,
         public modifiedBy?:string,
      
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/taskHistory.model.ts